import React from "react";
import { formInputInfo } from "../../../types/types";

interface Props {
  styles: string;
  item: formInputInfo;
  handleInputChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    array: boolean
  ) => void;
  value: string | string[];
}

export const ParticipantFormInput: React.FC<Props> = ({
  styles,
  value,
  item,
  handleInputChange,
}) => {
  const style = styles
    ? styles
    : "box-border py-4 pl-6 h-full w-full truncate relative";
  const isChecked = (option: string, checked: string[] | string) => {
    const toCheck = typeof checked === "string" ? [checked] : checked;
    return (
      toCheck.find((checkedOption) => checkedOption === option) !== undefined
    );
  };

  return item.type === "checkbox" ? (
    <fieldset className='flex justify-around'>
      {item.options.map((option) => (
        <div className='flex flex-col'>
          <label>{option}</label>
          <input
            className={"ml-6 my-2 w-5/6 py-4 truncate relative"}
            checked={isChecked(option, value)}
            value={option}
            id={item.id}
            type='checkbox'
            onChange={(e) => handleInputChange(e, true)}
          />
        </div>
      ))}
    </fieldset>
  ) : (
    <input
      className={style}
      value={value || ""}
      id={item.id}
      onChange={(e) => handleInputChange(e, false)}
    />
  );
};

export default ParticipantFormInput;
